interface Input {
  id: string; // variable.id
  varName?: string;
  name?: string; // value.name
  text?: string;
  value?: string | number | boolean | null; // value.value
  noPrintout?: boolean
}

interface Output extends Input {
  fullId: string;
  fullName: string;
}

export function mapAssignmentFullid(assignment: Input): string {
  return `${assignment.id}.${assignment.value}`;
}

export function mapMouseoverToValueText(assignment: Input): Output {
  return {
    ...assignment,
    fullId: assignment.id,
    fullName: `${assignment.varName} ${assignment.name}`
  };
}

export function mapMouseoverAssignmentToValueText(assignment: Input): Output {
  return {
    ...assignment,
    id: mapAssignmentFullid(assignment),
    fullId: mapAssignmentFullid(assignment),
    fullName: `${assignment.varName} ${assignment.name}`
  };
}

export function mapAssignmentToValueText(assignment: Input): Output {
  return {
    ...assignment,
    fullId: mapAssignmentFullid(assignment),
    fullName: `${assignment.varName} ${assignment.name}`
  };
}
